// PaymentResponsePage.jsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import crypto from "crypto-js";

const PaymentResponsePage = () => {
  const location = useLocation();
  const [responseData, setResponseData] = useState(null);
  const [isValidSignature, setIsValidSignature] = useState(false);

  // Your CyberSource secret key (should be handled securely)
  const SECRET_KEY =
    "1637ee920abc422d8003564e8d68ca66a090a7d1bdcb49598bac0f629f90ce9d8b87ad91ab084ec38efddabd41b4234d3c44315e8da04f7d87e35bd5cd03a383d9c919734e4a4c4ca3dec09445f2c7afee11a9d005a34d14964e15f3e14e7121559762f169f548c0b50bfb9b0e290145ccc5c4a9c5454a69b0935f76c3b939cc";

  useEffect(() => {
    const parseQueryString = (search) => {
      return search
        .substring(1)
        .split("&")
        .reduce((acc, pair) => {
          const [key, value] = pair.split("=");
          acc[decodeURIComponent(key)] = decodeURIComponent(value);
          return acc;
        }, {});
    };

    const verifySignature = (data) => {
      try {
        const signedFieldNames = data.signed_field_names.split(",");
        const dataToSign = signedFieldNames
          .map((field) => `${field}=${data[field]}`)
          .join(",");

        // Create HMAC SHA256 signature
        const signature = crypto
          .HmacSHA256(dataToSign, SECRET_KEY)
          .toString(crypto.enc.Base64);

        return signature === data.signature;
      } catch (error) {
        console.error("Signature verification failed:", error);
        return false;
      }
    };

    if (location.search) {
      const response = parseQueryString(location.search);
      const isValid = verifySignature(response);

      setResponseData(response);
      setIsValidSignature(isValid);
    }
  }, [location.search]);

  if (!responseData) {
    return <div>Loading payment response...</div>;
  }

  return (
    <div className="payment-response">
      <h1>
        Payment {responseData.decision === "ACCEPT" ? "Successful" : "Failed"}
      </h1>

      <div className="response-details">
        <p>Signature Valid: {isValidSignature ? "Yes" : "No"}</p>
        <p>Transaction ID: {responseData.transaction_id}</p>
        <p>Decision: {responseData.decision}</p>
        <p>
          Amount: {responseData.req_amount} {responseData.req_currency}
        </p>
        <p>Reason Code: {responseData.reason_code}</p>
        <p>Message: {responseData.message}</p>
        <p>Payment Token: {responseData.payment_token || "N/A"}</p>

        {responseData.decision === "ACCEPT" ? (
          <div className="success-message">
            <h2>Thank you for your payment!</h2>
            <p>Your transaction was processed successfully.</p>
          </div>
        ) : (
          <div className="error-message">
            <h2>Payment Processing Failed</h2>
            <p>Please try again or contact support.</p>
          </div>
        )}
      </div>

      <a href="/" className="return-link">
        Return to Store
      </a>
    </div>
  );
};

export default PaymentResponsePage;
